"use client";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import HomeBlogCard from "./HomeBlogCard";
import Button from "@/components/ui/button";
import { FALLBACK_BLOGS, BlogItem } from "@/data/blogData";
import { useBlog } from "@/context/Blog";

export default function HomeBlog() {
  const [blogsList, setBlogsList] = useState<BlogItem[]>(FALLBACK_BLOGS);
  let blogContext: any = null;

  try {
    // Attempt to read from BlogContext if provided in tree
    blogContext = useBlog();
  } catch (e) {
    // context optional fallback
  }

  useEffect(() => {
    if (
      blogContext?.blog &&
      Array.isArray(blogContext.blog) &&
      blogContext.blog.length > 0
    ) {
      // Map API blog format to BlogItem format if needed
      const mappedBlogs: BlogItem[] = blogContext.blog.map(
        (b: any, index: number) => ({
          _id: b._id || `blog-${index}`,
          blogId: b.blogId || b.slug || `blog-${index}`,
          title: b.title,
          description: b.description,
          slug: b.slug || b.blogId,
          banner:
            b.banner || FALLBACK_BLOGS[index % FALLBACK_BLOGS.length].banner,
          createdAt: b.createdAt || new Date().toISOString(),
          authorName: b.authorName || "Prem Gurung",
          authorImage: b.authorImage || "/Guides/Guide.jpg",
          category: b.category || "Himalaya Travel",
          readTime: b.readTime || "5 min read",
        }),
      );
      setBlogsList(mappedBlogs.slice(0, 3));
    }
  }, [blogContext?.blog]);

  // Ensure we always have at least 3 items to show
  const displayBlogs =
    blogsList.length >= 3
      ? blogsList.slice(0, 3)
      : [...blogsList, ...FALLBACK_BLOGS.slice(blogsList.length)].slice(0, 3);

  return (
    <section className="w-full bg-zinc-50/70 py-20 border-t border-b border-zinc-200/60 relative">
      <div className="w-11/12 3xl:w-8/12 mx-auto space-y-12">
        {/* Section Header */}
        <div className="flex flex-col items-center text-center space-y-4 max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold title tracking-tight text-zinc-900 uppercase">
            Latest From Our Blog
          </h2>

          <p className="text-zinc-600 text-sm sm:text-base leading-relaxed desc">
            Stay updated with expert Himalayan trekking tips, gear guides,
            high-altitude expedition preparation, and inspiring travel stories
            directly from our Sherpa guides.
          </p>
        </div>

        {/* 3 Blogs Responsive Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
          {displayBlogs.map((item, index) => (
            <HomeBlogCard key={item._id || item.blogId || index} item={item} />
          ))}
        </div>

        {/* Footer Link / View All Button */}
        <div className="flex justify-center pt-4">
          <Link href="/blogs">
            <Button>Explore All Blogs</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
